import React from 'react';

import styles from '@buyside/components/presentation/TickerUploader/tickerUploadStyles.scss';

const TickerPreUpload: React.FC = (): React.ReactElement => {
  return (
    <div className={styles.uploaderInstructions}>
      <div>
        <strong>Exporting from Excel:</strong>
        <ol>
          <li>Create a new spreadsheet</li>
          <li>
            Place all tickers in a single column with each ticker on its own row. Ensure that each
            ticker is in Bloomberg format (e.g. FB:US, TSCO:LN, 083790:KS)
          </li>
          <li>Select "Save As" and choose CSV from the file format options</li>
          <li>
            Your ticker file should look like this:
            <div>FB:US</div>
            <div>TSCO:LN</div>
            <div>083790:KS</div>
          </li>
          <li>Click the button below to upload the file</li>
        </ol>
      </div>
    </div>
  );
};

export default TickerPreUpload;
